import App from '../App';

window.App = App;
window.Section = null;


